<template>
  <div id="app">
    <formar-header class="sticky-element" />

    <router-view />

    <formar-footer />
  </div>
</template>
<script>
import formarHeader from "@/components/Header.vue";
import formarFooter from "@/components/Footer.vue";
export default {
  name: "app",
  components: {
    formarHeader,
    formarFooter,
  },
  data() {
    return {
      refreshing: false,
      registration: null,
      updateExists: false,
    };
  },
  created() {
    if (!window.sessionStorage.getItem("userData")) {
      // this.open()
    }
  },
  methods: {},
};
</script>

<style>
#app{
overflow: visible;
height: 100%;
}
.sticky-element {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  /* Define el punto donde el elemento se "pegará" */
  z-index: 1000;
  background-color: white;
  /* Fondo para visibilidad */
}
</style>
